/** 診断項目Excelのファイル名 */
export const INSPECTION_EXCEL_FILE_NAME = 'Inspection_Item_Management';
/** テンプレート管理Excelのファイル名 */
export const TEMPLATE_EXCEL_FILE_NAME = 'Template_Management';
/** 診断項目Excelの大項目のシート名 */
export const CATEGORY_SHEET_NAME = 'Category';
/** 診断項目Excelの中項目のシート名 */
export const TYPE_SHEET_NAME = 'Type';
/** 診断項目Excelの限度見本シート名 */
export const NG_SAMPLE_SHEET_NAME = 'NG_Sample';
/** 診断項目Excelの小項目のシート名 */
export const ITEM_SHEET_NAME = 'Item';
/** 診断項目Excelの小項目のシート名 */
export const ATTRIBUTE_SHEET_NAME = 'Attribute';
/** 診断項目Excelのテンプレートのシート名 */
export const TEMPLATE_SHEET_NAME = 'Template';
/** 診断項目Excelの会社情報のシート名 */
export const COMPANY_SHEET_NAME = 'Company';
/** インポート可能なExcelのフォーマットのリスト */
export const IMPORTABLE_EXCEL_FORMAT_LIST = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/vnd.ms-excel.sheet.macroEnabled.12',
];
/** マスタのドロップダウン */
export const CODE_MASTER_SELECTION = {
  P_CODE: { id: 0, key: 'LBL_P_CODE_MASTER' },
  F_CODE: { id: 1, key: 'LBL_F_CODE_MASTER' },
  R_CODE: { id: 2, key: 'LBL_R_CODE_MASTER' },
  R_CODE_REPAIR_PARTS: { id: 3, key: 'LBL_R_CODE_PARTS_MASTER' },
} as const;
/** 項目マスタのエクスポート */
export const ITEM_MANAGEMENT_OPTION = {
  INSPECTION_ITEM_MASTER: 0,
  CRITERIA_ITEM_MASTER: 1,
} as const;
/** 診断基準Excelのシート名 */
export const CRITERIA_SHEET_NAME = {
  CRITERIA: 'Criteria',
  MODEL_NAME_LIST: 'Model_List',
  ITEM_MASTER_LIST: 'Inspection_Item_List',
} as const;
/** 診断基準Excelのファイル名 */
export const CRITERIA_EXCEL_FILE_NAME = 'Criteria_Management';
/** ShopUse Excelのシート名 */
export const SHOP_USE_SHEET_NAME = 'Part_No';
/** ShopUse Excelのファイル名 */
export const SHOP_USE_FILE_NAME = 'ShopUse_Part_List';
/** パーツ選択画面の表示パターン */
export const PARTS_LIST_DISPLAY_PATTERN = {
  SECTION: { id: 1, key: 'LBL_PARTS_DISPLAY_SECTION' },
  R_CODE: { id: 2, key: 'LBL_PARTS_DISPLAY_R_CODE' },
};
/** 中項目の表示パターン */
export const INSPECTION_DISPLAY_TYPE = {
  STANDARD: { label: 'LBL_DISPLAY_TYPE_STANDARD', value: 1 },
  ACCORDION: { label: 'LBL_DISPLAY_TYPE_ACCORDION', value: 2 },
  MATRIX: { label: 'LBL_DISPLAY_TYPE_MATRIX', value: 3 },
};
/** マニュアルのページ指定可能範囲 */
export const VALID_MANUAL_PAGE_RANGE = {
  MIN: 1,
  MAX: 9999,
};
/** 小項目の判定条件 */
export const ITEM_CONDITIONS = {
  AND: { label: 'AND', value: 'AND' },
  OR: { label: 'OR', value: 'OR' },
};
/** 小項目のRコードリスト選択可能件数　 */
export const MANAGE_ITEM_MAX_R_CODE = 10;
/** マニュアルアップロードの拡張子 */
export const ACCEPT_TYPE_MANUAL = 'application/pdf';
/** NGサンプル画像アップロードの拡張子*/
export const ACCEPT_TYPE_NG_SAMPLE = 'image/jpeg, image/png';
/** NGサンプルのアップロードファイル上限数 */
export const ACCEPT_MAX_NG_SAMPLE = 30;
/** NGサンプル画像の上限(5MB) */
export const ACCEPT_SIZE_NG_SAMPLE = 1024 * 1024 * 5;
/** NGサンプル新規追加imageNoに仮で付与する番号 */
export const NEW_IMAGE_START_NO = 100;
/** 診断項目追加POSTするまで仮で付与するID */
export const MANAGE_ITEM_TEMP_ID = {
  CATEGORY: 'newCategory',
  TYPE: 'newType',
  ITEM: 'newItem',
};
/** 診断項目管理の表示モード */
export const MANAGE_ITEM_MODE = {
  /** 通常（操作可能） */
  VIEW: 0,
  /** 編集 */
  EDIT: 1,
  /** 追加 */
  ADD: 2,
  /** 並び替え */
  SORT: 3,
};
/** 診断項目管理の行の種類 */
export const MANAGE_ITEM_ROW_TYPE = {
  CATEGORY: 'CATEGORY',
  TYPE: 'TYPE',
  ITEM: 'ITEM',
};
/** ユーザー権限 */
export const USER_ROLE = {
  ADMIN: 1,
  AREA_MANAGER: 2,
  NORMAL_USER: 3,
};
